<template>
  <div class="copyright-component">
    <ym-icon name="copyright"
    />
    2013-{{ currYear }} 广州西柚教育信息咨询有限公司 |
    <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备14022458号</a>
    <div class="copyright-component-record-icon">
      <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010502001729"
         style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
        <img :src="require('@/assets/img/default/record_icon.png')" style="float:left;"/>
        <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 2px; color:#ccc;">
        粤公网安备 44010502001729号</p >
      </a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Copyright',
    computed: {
      currYear() {
        return new Date().getFullYear();
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .copyright-component {
    padding: @size-base 0;
    text-align: center;
    color: @color-text-disabled;
    font-size: @font-size-extra-extra-small;

    &-record-icon {
      a {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      img {
        margin-top: 6px;
        width: 30px;
        height: 30px;
      }
    }
  }
</style>
